import React, { useState, useEffect } from 'react';

const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: '#F59E0B',
        color: '#FFFFFF',
        textAlign: 'center',
        padding: isOffline ? '10px 16px' : 0,
        fontSize: 14,
        fontWeight: 500,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        overflow: 'hidden',
        maxHeight: isOffline ? 50 : 0,
        opacity: isOffline ? 1 : 0,
        transition: 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease',
      }}
    >
      Voce esta offline. Verifique sua conexao.
    </div>
  );
};

export default OfflineBanner;
